/**
 * Run Management API functions.
 *
 * Maps to backend modelling-api endpoints:
 *   POST   /api/runs                      - Create and execute a run
 *   GET    /api/runs                      - List runs (filterable by scenario_id, status)
 *   GET    /api/runs/:id                  - Get run status/metadata
 *   GET    /api/runs/:id/result           - Get run result (optimization output)
 */

import client from './client';

/**
 * Create and execute an optimization run.
 * @param {Object} data - { scenario_id }
 * @returns {Promise<Object>} Created run with status
 */
export const createRun = async (data) => {
  return client.post('/api/runs', data, {
    timeout: 120000, // 2 minutes - optimization can take time
  });
};

/**
 * List runs with optional filters.
 * @param {Object} [params] - { scenario_id?, status?, community_id?, skip?, limit? }
 * @returns {Promise<Array>} Array of run objects
 */
export const getRuns = async (params = {}) => {
  return client.get('/api/runs', { params });
};

/**
 * Get a single run by ID (status, metadata, solver info).
 * @param {string} runId - UUID
 * @returns {Promise<Object>} Run object
 */
export const getRun = async (runId) => {
  return client.get(`/api/runs/${runId}`);
};

/**
 * Get the result of a completed run (optimization output).
 * @param {string} runId - UUID
 * @returns {Promise<Object>} Full optimization result
 */
export const getRunResult = async (runId) => {
  return client.get(`/api/runs/${runId}/result`);
};
